import * as v from 'valibot';

import type { Hospital } from '../types';

export const hospitalSchema: v.GenericSchema<Hospital> = v.object(
  {
    location: v.string('Hospital location is missing'),
    address: v.string('Hospital address is missing'),
    state: v.string('Hospital state is missing'),
    lonLat: v.nullable(
      v.tuple(
        [v.number('Invalid longitude'), v.number('Invalid latitude')],
        'Invalid coordinates',
      ),
    ),
    timezone: v.string('Hospital timezone is missing'),
    code: v.string('Hospital code is missing'),
  },
  'Invalid hospital',
);
